import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy,
  Optional,
  Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cepMask]',
})
export class CepMask implements AfterViewInit, OnDestroy {
  private inputEl!: HTMLInputElement | null;
  private unlistenInput?: () => void;

  constructor(
    private host: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Optional() private ngControl: NgControl,
  ) {}

  ngAfterViewInit(): void {
    const hostEl = this.host.nativeElement;

    if (hostEl.tagName === 'INPUT') {
      this.inputEl = hostEl as HTMLInputElement;
    } else {
      this.inputEl = hostEl.querySelector('input');
    }

    if (!this.inputEl) {
      console.warn('cepMask: nenhum <input> encontrado no host.');
      return;
    }

    this.unlistenInput = this.renderer.listen(this.inputEl, 'input', (e: Event) => this.onInput(e));

    this.formatAndSync(this.inputEl.value, { emitToControl: false });
  }

  ngOnDestroy(): void {
    if (this.unlistenInput) this.unlistenInput();
  }

  private onInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.formatAndSync(target.value, { fromEvent: true });
  }

  private formatAndSync(
    rawValue: string,
    opts: { fromEvent?: boolean; emitToControl?: boolean } = {},
  ) {
    if (!this.inputEl) return;

    const numeric = rawValue.replace(/\D/g, '');
    const masked = this.applyCEPMask(numeric);

    if (this.inputEl.value !== masked) {
      this.renderer.setProperty(this.inputEl, 'value', masked);
    }

    if (this.ngControl && this.ngControl.control) {
      try {
        this.ngControl.control.setValue(masked, { emitEvent: false });
      } catch (err) {}
    } else if (opts.fromEvent) {
      const ev = new Event('input', { bubbles: true, cancelable: true });
      this.inputEl.dispatchEvent(ev);
    }
  }

  private applyCEPMask(value: string) {
    let numbers = value.replace(/\D/g, '');

    numbers = numbers.substring(0, 8);

    let formatted = numbers;

    if (numbers.length > 5) {
      formatted = numbers.substring(0, 5) + '-' + numbers.substring(5);
    }

    return formatted;
  }
}
